import dayjs from 'dayjs';
import consts from '../consts';
import Model from '../models/model';
import util from '../util';

const { renderAttachmentButton, bIResultRenderer } = util;

const TestControlRenderer = ({ row }) => {

	let toReturn = " ";
	if (row.BIResult === consts.BIResult.Error) {
		toReturn = 'Error';
	}
	else {
		toReturn = row.BITypeId === consts.TestOrControl.Test ? 'Test' : 'Control';
	}
	return toReturn;

}

const model = new Model({
	name: 'IncubatorCycle',
	defaultSort: 'BIInTime DESC',
	disableAdd: false,
	disableDelete: true,
	title: 'IncubatorCycleList',
	formTitleField: 'Incubator',
	showGridRefreshBtn: true,
	combos: [
		{ type: 'EquipmentType', loaded: true },
		{ type: 'TestOrControl', loaded: true }
	],
	columns: [
		{
			field: 'BIInTime',
			header: "DateTime",
			type: 'dateTime',
			width: 200,
			isNotformfield: true,
		},
		{
			field: 'Incubator',
			header: "Incubator",
			width: 200,
		},
		{
			field: 'Well',
			header: "NumberOfWell",
			width: 130,
			align:'right',
			headerAlign:'right',
		},
		{
			field: 'BITypeId',
			header: "TestControl",
			width: 100,
			lookup: 'TestOrControl',
			renderCell: TestControlRenderer
		},
		{
			field: 'LotNumber',
			header: "LotNumber",
			width: 100,
		},
		{
			field: 'SerialNumber',
			header: "SNo",
			width: 120,
		},
		{
			field: 'LoadNumber',
			header: "Load",
			width: 120,
		},
		{
			field: 'BIResultIcon',
			header: "Result",
			width: 100,
			renderCell: bIResultRenderer
		},
		{
			field: 'Sterilizer',
			header: "Sterilizer",
			width: 200,
		},
		{
			field: 'CycleCount',
			header: "Cycle",
			width: 100,
			align:'right',
			headerAlign:'right'
		},
		{
			field: 'AcknowledgeTime',
			header: "AcknowledgedDate",
			width: 200,
			type: 'date',
			skipTime: true,
			isLocal: true,
		},
		{
			field: 'AttachFile',
			header: "AttachFile",
			width: 150,
			renderCell: ({ row }) => (renderAttachmentButton(row, true)),
			filterable: false,
			isNotExportField: true
		},
		{
			field: 'startDate',
			header: 'Start Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			filterable: false,
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			hidden: true
		},
		{
			field: 'endDate',
			header: 'End Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			hidden: true
		}
	]
});
export const IncubatorTable = model;
export default model.createGridBase();